import { Fetch } from 'lib/Fetch';

export function regionsService() {
  return new Fetch()
    .url('/regions/list/colombia')
    .method('get')
    .send();
}
